import React from 'react';
import { Link } from "react-scroll";
import * as Icon from "react-feather";

const Welcome = () => {

    return (
        <section id="home">
            <div className="mi-home-area mi-padding-section">
                <div className="container">
                    <div className="row">
                        <div className="col-10 text-center mx-auto">
                            <h1 className="d-none d-md-block">I'm <span className="color-theme">Pablo Mejia</span></h1>
                            <h1 className="d-block d-md-none"><span className="color-theme">Pablo Mejia</span></h1>
                            <p className="text-5 text-light mb-4">Medellín - Colombia.</p>
                            <Link
                                className="btn btn-outline-primary rounded-pill shadow-none smooth-scroll mt-2"
                                to="contact"
                                spy={true}
                                smooth={true}
                                offset={0}
                                duration={2000}
                            >Hire Me</Link>
                        </div>
                    </div>
                </div>
                <Link
                    className="scroll-down-arrow text-white smooth-scroll"
                    to="about"
                    spy={true}
                    smooth={true}
                    offset={0}
                    duration={1000}
                ><span className="animated"><Icon.ChevronDown/></span></Link>
            </div>
        </section>
    );
}
 
export default Welcome;